import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useInjection } from '@core/providers/inversify-react.provider'
import { LogoutPresenter } from '@core/infra/authentication/logout.presenter'

export const AvatarMenuComponent = observer(() => {
  const presenter: LogoutPresenter = useInjection(LogoutPresenter)
  const [open, setOpen] = useState(false)
  const vm = presenter.viewModel

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center rounded-full"
        aria-label={vm.accountMenuLabel}
      >
        <span
          aria-hidden="true"
          className="flex size-8 items-center justify-center rounded-full bg-shell-accent text-xs font-semibold text-white"
        >
          {vm.initials}
        </span>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full z-20 mt-2.5 w-56 origin-top-right rounded-md bg-shell-surface py-2 shadow-lg outline-1 outline-shell-border">
            <div className="px-3 py-2">
              <p className="truncate text-sm/6 font-semibold text-shell-ink">{vm.displayName}</p>
              {vm.email && <p className="truncate text-xs text-shell-ink-muted">{vm.email}</p>}
            </div>

            <div aria-hidden="true" className="my-1 h-px bg-shell-border" />

            <button
              type="button"
              onClick={() => presenter.logout()}
              className="mx-2 block w-[calc(100%-1rem)] rounded-md px-3 py-1 text-left text-sm/6 font-semibold text-red-600 hover:bg-red-50 dark:hover:bg-red-950/40"
            >
              {vm.logoutLabel}
            </button>
          </div>
        </>
      )}
    </div>
  )
})
